import { Link } from 'react-router-dom';
import {
  Card,
  CardFooter,
  CardHeader,
  CardContent,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/card';
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import { categoryIcons } from '@Constants/iconMap';
import { FlowCategory } from '@Types/flowCategory';

interface FlowCategoryCardProps {
  category: FlowCategory;
}

export default function WorkspaceCard({ category }: FlowCategoryCardProps) {
  const categoryColor = category.color ?? 'red-500';
  const categoryIcon = categoryIcons[category.icon];

  return (
    <Card
      key={category.id}
      className="h-75 justify-between gap-2 border-t-40 pt-0"
      style={{ borderTopColor: categoryColor }}
    >
      <div className="flex min-h-0 flex-1 flex-col">
        <div className="flex w-full justify-end pr-4">
          <div className="-mt-5 rounded-3xl bg-white p-4">
            {categoryIcon?.icon}
          </div>
        </div>

        <CardHeader className="flex flex-col gap-0">
          <Heading level="h4" className="text-ellipsis">
            {category.name}
          </Heading>
          {/* <p className="line-clamp-2 text-xs">{category.description}</p> */}
        </CardHeader>
        <CardContent className="min-h-0 flex-1 overflow-auto rounded-md py-2">
          {category.flows?.length > 0 && (
            <div>
              <div className="mb-1 flex items-center gap-2">
                <span className="text-muted-foreground text-xs font-medium tracking-wide uppercase">
                  flows
                </span>
                <span className="bg-muted border-border text-muted-foreground rounded-full border px-1.5 py-0.25 text-xs">
                  {category.flows.length}
                </span>
              </div>
              <div className="ml-2 flex h-full flex-col gap-1">
                {category.flows.map((flow) => (
                  <div key={flow.id}>
                    <Link
                      to={`/flows/list?page=1&categoryFilter=${category.id}&flowFilter=${flow.id}`}
                      className="text-muted-foreground flex w-fit items-center gap-2 rounded-md text-sm hover:text-black"
                    >
                      <span
                        className="h-1.5 w-1.5 flex-shrink-0 rounded-full"
                        style={{ backgroundColor: categoryColor }}
                      />
                      <span className="truncate text-xs">{flow.flowTitle}</span>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          )}
        </CardContent>
      </div>

      <CardFooter className="shrink-0">
        <div className="flex w-full flex-col justify-center gap-2">
          <Button asChild variant="secondary">
            <Link to={`/flows/list?page=1&categoryFilter=${category.id}`}>
              View Flow Activity
            </Link>
          </Button>
          <Button asChild variant="secondary">
            <Link to={`/flows/cards/${category.id}`}>
              View Category Details
            </Link>
          </Button>
        </div>
      </CardFooter>
    </Card>
  );
}
